export class GoogleMapLoader
{
    loadMapFor(googleApiKey: string): Promise<{}>
    {
        if(typeof googleApiKey !== 'string')
            return Promise.resolve({});
        
        return new Promise(resolve => {
            if(!window['google']) {
                const script = document.createElement('script');
                script.setAttribute('src',`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}`);
                script.async = false;
                script.onload = resolve;
                document.head.appendChild(script);
            } else {
                resolve();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/utils/GoogleMapLoader.ts